
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { BarChart4 } from "lucide-react";

const EmptyState = () => {
  return (
    <Card className="text-center py-12">
      <CardContent>
        <div className="mb-4">
          <BarChart4 className="mx-auto h-12 w-12 text-muted-foreground" />
        </div>
        <h3 className="text-lg font-medium">No data available</h3>
        <p className="text-muted-foreground mt-2">Add students and programs to generate reports.</p>
      </CardContent>
    </Card>
  );
};

export default EmptyState;
